import {
    FormControl,
    FormHelperText,
    FormLabel,
    InputLabel,
    MenuItem,
    Select,
    Slider,
    styled,
} from '@mui/material';
import { Controller, useController } from 'react-hook-form';

const PrettoSlider = styled(Slider)({
    color: '#52af77',
    height: 5,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#000000',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&::before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
  });
  
const ReactSlider = (props) => {
    const {
      hookFormControl,
      label,
      varName,
      disabled = false,
      errorMessage = null,
      helperText = null,
      width = '100%',
      minValue = 0,
      maxValue = 100,
      minDistance = 1,
      sx = {},
      formLabel
    } = props;

    const { field } = useController({ name: varName, control: hookFormControl })
    const oldValue = field?.value || [minValue, maxValue];

    const handleChange = (event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) {
          return;
        }
    
        if (activeThumb === 0) {
            field.onChange([Math.min(newValue[0], oldValue[1] - minDistance), oldValue[1]]);
        } else {
            field.onChange([oldValue[0], Math.max(newValue[1], oldValue[0] + minDistance)]);
        }
    };
  
    return (
        <FormControl error={errorMessage !== null} fullWidth sx={{ width }}>
            {formLabel && (
                <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">{formLabel}</FormLabel>
            )}
            <label htmlFor="floating_outlined" className="select-none absolute text-[15px] font-[400] text-[#7b809a] duration-200 transform -translate-y-4 scale-75 top-1 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-[#116189] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-[25px] left-1 font-['Poppins-Regular']">{label}</label>
            <div className='px-4'>
                <PrettoSlider
                    value={oldValue}
                    onChange={handleChange}
                    className='mt-[60px]'
                    disableSwap
                    max={maxValue}
                    min={minValue}
                    sx={sx}
                    valueLabelDisplay="on"
                />
            </div>
            {!errorMessage && helperText && (
                <FormHelperText className="ml-0 font-['Poppins-Regular']" id="component-info-text">
                    {helperText}
                </FormHelperText>
            )}
            {errorMessage && (
                <FormHelperText className="ml-0 font-['Poppins-Regular']" id="component-error-text">
                    {errorMessage}
                </FormHelperText>
            )}
        </FormControl>
    );
};
  
export default ReactSlider;
  